<!-- 两个表单公用的表头 -->

<template>
  <div id="HeaderInfo">
    <div>
      <el-form ref="form" :model="form" label-width="80px">
              <el-row>
                  <el-col :span="8">
                      <el-form-item label="考生信息：">
                          <el-input placeholder="可搜索姓名或手机号"></el-input>
                        </el-form-item>
                    </el-col>
                  <el-col :span="8">
                      <el-form-item label="工种：">
                          <el-select placeholder="全部工种">
                              <el-option label="健康管理师" value="全部工种"></el-option>
                              <el-option label="健康管理师" value="鸡"></el-option>
                              <el-option label="健康管理师" value="鸭"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                  <el-col :span="8">
                      <el-form-item label="科目：">
                          <el-input placeholder="可选择考试科目"></el-input>
              <el-option label="理论" value="鸡"></el-option>
                            <el-option label="实操" value="鸭"></el-option>
                       
            </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
    </div>
    <div>
      <el-form ref="form" :model="form" label-width="80px">
              <el-row>
                  <el-col :span="8">
                      <el-form-item label="等级：">
                          <el-input placeholder="可选择考试等级"></el-input>
                        </el-form-item>
                    </el-col>
                  <el-col :span="8">
                      <el-form-item label="支付状态：">
                          <el-select placeholder="全部工种">
                <el-option label="待确认" value="全部工种"></el-option>
                              <el-option label="已支付" value="鸡"></el-option>
                           
              </el-select>
                        </el-form-item>
                    </el-col>
                  <el-col :span="8">
                      <el-form-item label="审核结果：">
                          <el-input placeholder="可选择考试科目"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
    </div>
    <Table />
  </div>
</template>
 
<script>
import Table from "./Table.vue";
import { Toast } from "vant";
export default {
  name: "HeaderInfo",
  components: { Table },
  data() {
    return {
      restaurants: [],
      state: '',
      timeout: null
    };
  },
  methods: {
    loadAll() {
      return [
        { "value": "三全鲜食（北新泾店）", "address": "长宁区新渔路144号" },
        { "value": "Hot honey 首尔炸鸡（仙霞路）", "address": "上海市长宁区淞虹路661号" },
        { "value": "新旺角茶餐厅", "address": "上海市普陀区真北路988号创邑金沙谷6号楼113" },
        { "value": "泷千家(天山西路店)", "address": "天山西路438号" },
        { "value": "胖仙女纸杯蛋糕（上海凌空店）", "address": "上海市长宁区金钟路968号1幢18号楼一层商铺18-101" },
        { "value": "贡茶", "address": "上海市长宁区金钟路633号" },
        { "value": "豪大大香鸡排超级奶爸", "address": "上海市嘉定区曹安公路曹安路1685号" },
        { "value": "茶芝兰（奶茶，手抓饼）", "address": "上海市普陀区同普路1435号" },
        { "value": "十二泷町", "address": "上海市北翟路1444弄81号B幢-107" },
        { "value": "星移浓缩咖啡", "address": "上海市嘉定区新郁路817号" },
        { "value": "阿姨奶茶/豪大大", "address": "嘉定区曹安路1611号" },
        { "value": "新麦甜四季甜品炸鸡", "address": "嘉定区曹安公路2383弄55号" },
        { "value": "Monica摩托主题咖啡店", "address": "嘉定区江桥镇曹安公路2409号1F，2383弄62号1F" },
        { "value": "浮生若茶（凌空soho店）", "address": "上海长宁区金钟路968号9号楼地下一层" },
        { "value": "NONO JUICE  鲜榨果汁", "address": "上海市长宁区天山西路119号" },




      ];
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      console.log(item);
    }
  },
  mounted() {
    this.restaurants = this.loadAll();
  }
};
</script>
  <style>
  #HeaderInfo {
    height: 397px;
    width: 2312px;
  }
  </style>